var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('div',{staticClass:"ContentQuote"},[_c('p',{staticClass:"ContentQuote__quote",domProps:{"innerHTML":_vm._s(_vm.content.quote)}}),(_vm.hasAuthor)?_c('p',[_vm._v(_vm._s(_vm.content.author))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }